export default __webpack_public_path__ + "static/media/FlatGenericOTSPFullSize.376b7fdc.png";